module["exports"] = ["Пан", "Пані"];